<template>
  <div id="app">
    <!-- 页头 -->
    <header v-show="showHeader">
      <component :is="header" ref="header"></component>
      <!-- <main-header /> -->
    </header>
    <!-- 导航 -->
    <nav v-show="showNav">
      <keep-alive>
        <component :is="nav"></component>
      </keep-alive>
    </nav>
    <!-- 内容 -->
    <article>
      <router-view></router-view>
      <!-- <div class="loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div> -->
    </article>
    <!-- 登录框 -->
    <article v-if="showLogin">
      <c-login :show.sync="showLogin" :call-back-route="callBackRoute" :path="loginMoadlType"/>
    </article>

    <!-- 页脚 -->
    <footer v-show="showFooter">
      <!-- 缓存组件 -->
      <keep-alive>
        <component :is="footer"></component>
      </keep-alive>
      <!-- <main-footer /> -->
    </footer>
  </div>
</template>

<script>
import mainHeader from './components/header/mainHeader.vue';
import navHeader from './components/header/nav.vue';
import mainFooter from './components/footer/mainFooter.vue';
import CLogin from './views/user/login.vue';

export default {
  name: 'app',
  components: {
    mainHeader,
    navHeader,
    mainFooter,
    CLogin,
  },
  data() {
    return {
      header: 'main-header',
      footer: 'main-footer',
      nav: 'nav-header',
      showNav: true, // 是否显示导航
      showHeader: true, // 是否显示头部
      showFooter: true, // 是否显示页脚
      showLogin: false, // 是否显示登录框
      callBackRoute: '',
      loginMoadlType: 'login',
    };
  },
  methods: {
    openLoginModal(callBackRoute = '', type = 'login') {
      // 打开登录框
      if (this.loginMoadlType !== type) {
        this.loginMoadlType = type;
      }
      if (!this.$service.user.getUser().check()) {
        this.showLogin = true;
      }
      if (callBackRoute) {
        this.callBackRoute = callBackRoute;
      }
    },
  },
};

</script>

<style scoped>
html body{
  font-family: "Microsoft YaHei","微软雅黑","Helvetica Neue",Helvetica,STHeiTi,tahoma,Arial,sans-serif;
}
#app {
  height: 100vh;
  overflow: auto;
}
#app header {
  margin: 15px auto 0 auto;
}
#app nav {
  height: 77px;
}
/* #app article {
  overflow: hidden
} */
</style>

<!-- <style lang="sass" scoped>
@-webkit-keyframes load
  0%
    opacity: 1
  100%
    opacity: 0
.loadEffect
  width: 32px
  height: 32px
  position: relative
  margin: 0 auto
  margin-top: 100px
  span
    display: inline-block
    width: 8px
    height: 3px
    border-top-left-radius: 5px
    border-bottom-left-radius: 5px
    background: rgb(179, 179, 179)
    position: absolute
    -webkit-animation: load 1.04s ease infinite
    &:nth-child(1)
      left: 2px
      top: 50%
      -webkit-animation-delay: 0.1s
    &:nth-child(2)
      left: 2.5px
      top: 9px
      transform: rotate(30deg)
      animation-delay: 0.2s
    &:nth-child(3)
      left: 4.5px
      top: 3px
      transform: rotate(60deg)
      animation-delay: 0.3s
    &:nth-child(4)
      left: 8px
      top: 0%
      transform: rotate(90deg)
      animation-delay: 0.4s
    &:nth-child(5)
      right: 1px
      top: 2px
      transform: rotate(120deg)
      animation-delay: 0.5s
    &:nth-child(6)
      right: -3px
      top: 7px
      transform: rotate(150deg)
      animation-delay: 0.6s
    &:nth-child(7)
      bottom: 10px
      left: 50%
      transform: rotate(180deg)
      animation-delay: 0.7s
    &:nth-child(8)
      bottom: 20px
      left: 10px
      transform: rotate(212deg)
      animation-delay: 0.8s
    &:nth-child(9)
      bottom: 20px
      left: 10px
      transform: rotate(242deg)
      animation-delay: 0.9s
    &:nth-child(10)
      bottom: 20px
      left: 10px
      transform: rotate(272deg)
      animation-delay: 1s
    &:nth-child(11)
      bottom: 20px
      left: 10px
      transform: rotate(302deg)
      animation-delay: 1.1s
    &:nth-child(12)
      bottom: 20px
      left: 10px
      transform: rotate(332deg)
      animation-delay: 1.1s
</style>-->
